import { ChevronDown } from '@interhyp/platform-icons';
import React, { useCallback } from 'react';
import { LegacyIconRenderer } from "../../../../helper/components/LegacyIconRenderer.js";
import { useDataGrid } from "../../hooks/useDataGrid.js";
import styles from "./CollapsibleCell.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const CollapsibleCell = /*#__PURE__*/React.memo(({
  onClick,
  id
}) => {
  const {
    activeRow
  } = useDataGrid();
  const isOpen = activeRow.open === id;
  const handleClick = useCallback(e => {
    e.stopPropagation();
    onClick(id);
  }, [id, onClick]);
  return /*#__PURE__*/_jsx("div", {
    className: styles.collapsibleCell,
    onClick: handleClick,
    children: /*#__PURE__*/_jsx(LegacyIconRenderer, {
      className: isOpen ? styles.open : styles.closed,
      icon: ChevronDown
    })
  });
});